<template>
  <img v-bind="$attrs" :src="src" v-show="isLoaded && !isError" @load="loaded" @error="onError" />

  <LoadingIndicator v-if="!isLoaded && !isError" />

  <View v-if="isError" gap="md" direction="column" align="center">
    <Icon name="image-x" size="large" />
    <Text variant="body-large">Unable to load image</Text>
  </View>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { Icon, LoadingIndicator, Text, View } from '@tallo/design-system';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{ src: string }>();
const isLoaded = ref(false);
const isError = ref(false);

function loaded() {
  isLoaded.value = true;
}

function onError() {
  isError.value = true;
}

watch(
  () => props.src,
  () => {
    isLoaded.value = false;
    isError.value = false;
  },
);
</script>

<style scoped lang="scss">
img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
